import './custom_highchart.js.coffee'
Monitoring.Views.Charts ||= {}

class Monitoring.Views.Charts.CustomProfileModerationChart extends Monitoring.Views.Charts.CustomHighchart
  url: '/monitoring/dashboard/charts/moderation'

  initialize: (@options = {}) ->
    super(@options)
    @_customOptions = @options.customOptions || {}

  series: ->
    @data.series

  customOptions: ->
    options = {
      chart:
        type: 'bar'
        marginTop: 0
        marginBottom: 0
      title:
        text: null
      xAxis:
        visible: false # TODO this will work after updating highcharts
        # The following are a workaround
        categories: ['Results']
        title:
          text: null
      yAxis:
        visible: false # TODO this will work after updating highcharts
        # The following are a workaround
        min: 0
        title:
          text: null
        labels:
          enabled: false
      tooltip:
        followPointer: true
        positioner: (labelWidth, labelHeight, point) ->
          chart = this.chart
          pointX = if (point.plotX + labelWidth > chart.plotWidth) then point.plotX + chart.plotLeft - labelWidth - 10 else point.plotX + chart.plotLeft + 10
          x = if pointX > 0 then pointX else 0
          y = if point.plotY + chart.plotTop - 20 > 35 then point.plotY + chart.plotTop - 20 else 35
          return { x: x , y: y }
        pointFormat: '<span>{series.name}</span>: <b>{point.y}</b>',
      plotOptions:
        bar:
          dataLabels:
            enabled: true
            format: '{point.percentage:.0f}%'
            color: 'white'
            verticalAlign: 'top'
            style:
              fontSize: '13px'
        series:
          stacking: 'percent'
      legend:
        enabled: false
      credits:
        enabled: false
      exporting:
        enabled: false
    }
    $.extend(true, options, @_customOptions)
    return options

  getSearchQuery: ->
    @searchQuery.deepCopy()
